<script setup lang="ts">

import CarbucksApp from '@presentation/Icons/CarbucksApp.vue';

</script>

<template>

    <Page>

        <ImageAndText 
            src="/WhatIsCarbucks/app.png"
            image-class="max-w-[300px] drop-shadow-xl"
            animation="slide-up"
            flip
            floor-shadow>

            <Animated :delay="500" :duration="500" animation="slide-left">
                <CarbucksApp />
            </Animated>

            <h2 class="my-4">The Carbucks App</h2>
            <p class="font-normal text-white/80">
                Revolutionising automotive experiences with exclusive deals, 
                personalised recommendations, and effortless scheduling – 
                making your journey easier and more rewarding.
            </p>

        </ImageAndText>

    </Page>

</template>